<template>
  <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
    <br />
    <div class="col-12">
      <!-- <h5 style="color: var(--primary-color)">
        Congratulations, {{ entityDetails ? entityDetails.entityName : '' }} your application has been approved.
      </h5> -->
      <h5 style="color: var(--primary-color)">
        Congratulations! Now that your credit application has been approved, you need to review and sign the lease documentation.
      </h5>
      <p>Please continue to view and sign the lease agreement.</p>
    </div>

    <br />
    <DigitalModule />
    <br />
    <br />

    <div class="q-px-lg q-py-lg" style="text-align: center">
      <QBtn color="primary" outline no-caps @click="onClickHandler()">Log Out</QBtn>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapState } from 'vuex';
import DigitalModule from './DigitalModule.vue';

export default {
  name: 'DigitalSignature',
  components: { QBtn, DigitalModule },
  props: [],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    entityDetails() {
      return this.scoreboard?.entityDetails ? this.scoreboard?.entityDetails : null;
    }
  },
  created() {},
  data: function () {
    return {};
  },
  methods: {
    onClickHandler: function () {
      this.$router.push({ name: 'logout' });
    }
  }
};
</script>
